import React from 'react';

function TestimonialSection() {
  const testimonials = [
    {
      quote: "Therapy Simplified is exactly what I needed. Parinita helped me understand my anxiety triggers without using complex medical jargon. I finally feel in control.",
      author: "Anonymous Client",
      tag: "Anxiety Management"
    },
    {
      quote: "Our marriage was on the rocks, but her couples counseling sessions gave us a safe space to communicate. We learned so much about our attachment styles.",
      author: "Married Couple, Kolkata",
      tag: "Couples Counseling"
    },
    {
      quote: "The mindfulness techniques she taught me have completely changed how I handle work stress. Truly a life-changing experience.",
      author: "Corporate Professional",
      tag: "Stress & Wellness"
    }
  ];

  return (
    <section className="py-24 px-6 md:px-16 lg:px-24 bg-ocean-teal/5">
      <div className="max-w-7xl mx-auto">
        <header className="text-center mb-16">
          <span className="text-xs font-black uppercase tracking-[0.3em] text-ocean-teal">Success Stories</span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mt-4 text-deep-charcoal">Words of Healing</h2>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((item, index) => (
            <div key={index} className="bg-white p-10 rounded-[3rem] shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-500 relative">
              <div className="text-6xl text-ocean-teal/20 font-serif absolute top-6 left-8">"</div>
              <p className="text-deep-charcoal/80 leading-relaxed relative z-10 mt-6 italic">
                {item.quote}
              </p>
              <div className="mt-8 pt-6 border-t border-gray-50">
                <h4 className="font-bold text-deep-charcoal">{item.author}</h4>
                <span className="text-[10px] font-black uppercase tracking-widest text-ocean-teal mt-1 block">
                  {item.tag}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TestimonialSection;